import { render, staticRenderFns } from "./CreditsGranted.vue?vue&type=template&id=106c280e&"
import script from "./CreditsGranted.vue?vue&type=script&lang=js&"
export * from "./CreditsGranted.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports